import NotificationService from './NotificationService';

export default NotificationService;
